import { render, staticRenderFns } from "./purchaseNotes.vue?vue&type=template&id=6d0385da&scoped=true"
import script from "./purchaseNotes.vue?vue&type=script&lang=js"
export * from "./purchaseNotes.vue?vue&type=script&lang=js"
import style0 from "./purchaseNotes.vue?vue&type=style&index=0&id=6d0385da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0385da",
  null
  
)

export default component.exports